export default __webpack_public_path__ + "static/experiment-f7977cbe6d384b65e665d2539192ac0e.png";